"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import dynamic from "next/dynamic";
import { X } from "lucide-react";
import { getUser } from "@/lib/auth";

// Rendered client-side only so password manager extensions can't cause
// hydration mismatches by injecting DOM nodes during SSR→client reconciliation.
const LoginForm = dynamic(() => import("./LoginForm"), { ssr: false });

export default function LoginPage() {
  const router = useRouter();

  useEffect(() => {
    if (getUser()) router.replace("/dashboard");
  }, [router]);

  return (
    <div className="min-h-screen bg-[#F2F0EC] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-8 relative">

        <div className="flex items-center justify-between mb-7">
          <img src="/flintly-wordmark.png" alt="Flintly" className="h-8 w-auto object-contain" />
          <div className="w-7 h-7 flex items-center justify-center rounded-full text-[#9E9890]">
            <X className="w-4 h-4" />
          </div>
        </div>

        <h1 className="text-[22px] font-bold text-[#1A1814] tracking-[-0.02em] mb-1">Welcome back</h1>
        <p className="text-[14px] text-[#9E9890] mb-7">Sign in to your account</p>

        <LoginForm />

      </div>
    </div>
  );
}
